import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedalsComponent } from "./medals/medals.component";
import { ReportsRoutingModule } from "./reports-routing.module";
import { ScheduleSportComponent } from "./schedule-sport/schedule-sport.component";
import { ScheduleUserComponent } from "./schedule-user/schedule-user.component";
import { ScheduleComponent } from "./schedule/schedule.component";
import { SummaryUserComponent } from "./summary-user/summary-user.component";
import { SummarySportComponent } from "./summary-sport/summary-sport.component";
import { ScheduleSportDetailComponent } from "./schedule-sport-detail/schedule-sport-detail.component";
import { ScheduleSportOverviewComponent } from "./schedule-sport-overview/schedule-sport-overview.component";
import { AddScheduleComponent } from "./add-schedule/add-schedule.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { EditScheduleComponent } from "./edit-schedule/edit-schedule.component";
import { PublicViewComponent } from "./public-view/public-view.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { SummarySportListComponent } from "./summary-sport-list/summary-sport-list.component";
import { SummaryCategoryListComponent } from "./summary-category-list/summary-category-list.component";
import { SummaryFixtureListComponent } from "./summary-fixture-list/summary-fixture-list.component";
import { SummaryFixtureAddComponent } from "./summary-fixture-add/summary-fixture-add.component";
import { ResultSportsComponent } from "./result-sports/result-sports.component";
import { ResultCategoryComponent } from "./result-category/result-category.component";
import { ResultFixtureComponent } from "./result-fixture/result-fixture.component";
import { PublicMedalComponent } from "./public-medal/public-medal.component";
import { PublicResultComponent } from "./public-result/public-result.component";
import { DailyResultComponent } from "./daily-result/daily-result.component";
import { PubilcUserResultComponent } from "./pubilc-user-result/pubilc-user-result.component";
import { SummaryFixtureListDetailComponent } from "./summary-fixture-list-detail/summary-fixture-list-detail.component";
import { PublicSportComponent } from "./public-sport/public-sport.component";
import { PublicSportCategoryComponent } from "./public-sport-category/public-sport-category.component";
import { PublicSportCategoryFixtureComponent } from "./public-sport-category-fixture/public-sport-category-fixture.component";
import { PublicSportHighlightComponent } from "./public-sport-highlight/public-sport-highlight.component";
import { OrderByGfPipe } from "../shared/pipe/orderByGf.pipe";
import { OrderByScore } from "../shared/pipe/orderByScore.pipe";
import { OrderByPoint } from "../shared/pipe/orderByPoint.pipe";
import { SportFixturesComponent } from "./sport-fixtures/sport-fixtures.component";
import { OrderByASC } from "../shared/pipe/orderByASC.pipe";

@NgModule({
    declarations: [
        MedalsComponent,
        ScheduleSportComponent,
        ScheduleUserComponent,
        ScheduleComponent,
        SummaryUserComponent,
        SummarySportComponent,
        ScheduleSportDetailComponent,
        ScheduleSportOverviewComponent,
        AddScheduleComponent,
        EditScheduleComponent,
        PublicViewComponent,
        SummarySportListComponent,
        SummaryCategoryListComponent,
        SummaryFixtureListComponent,
        SummaryFixtureAddComponent,
        ResultSportsComponent,
        ResultCategoryComponent,
        ResultFixtureComponent,
        PublicMedalComponent,
        PublicResultComponent,
        DailyResultComponent,
        PubilcUserResultComponent,
        SummaryFixtureListDetailComponent,
        PublicSportComponent,
        PublicSportCategoryComponent,
        PublicSportCategoryFixtureComponent,
        PublicSportHighlightComponent,
        OrderByGfPipe,
        OrderByScore,
        OrderByPoint,
        OrderByASC,
        SportFixturesComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        ReportsRoutingModule,
        FormsModule,
        FullCalendarModule,
        ReactiveFormsModule,
    ],
})
export class ReportsModule {}
